import React, { useState, useEffect } from "react";
import {
  MapContainer,
  TileLayer,
  GeoJSON,
  Polygon,
  Circle,
  CircleMarker,
  Popup,
} from "react-leaflet";

import "leaflet/dist/leaflet.css";
//import mapData from "../../data/south-africa-provinces.json";
//import mapData from "../../data/eastern-cape-districts.json";
import mapData from "../../data/maps/sa-districts.json";

import "../../styles/map.css";

const DistrictMap = ({
  data,
  hoverText,
  dataSource,
  width = "95%",
  annotatedCssContainer = "census-info-hover",
  annotatedCssText = "census-info",
}) => {
  // Centre of South Africa
  const center = [-29.4856, 26.124];

  const [onselect, setOnselect] = useState({});
  /* function determining what should happen onmouseover, this function updates our state*/

  const mapDisplayData = { ...mapData };

  const resetHighlight = (e) => {
    setOnselect({});
    e.target.setStyle(style(e.target.feature));
  };

 
  const highlightFeature = (e) => {
    var layer = e.target;
    const { name, NYSEvents } = e.target.feature.properties;
    setOnselect({
      name: name,
      NYSEvents: NYSEvents,
    });
    layer.setStyle(highlightStyle);
  };

  const highlightStyle = {
    weight: 1,
    color: "black",
    fillOpacity: 1,
  };

  const onEachFeature = (feature, layer) => {
    layer.on({
      mouseover: highlightFeature,
      mouseout: resetHighlight,
    });
  };

  const mapPolygonColorToEvents = (numberOfEvents) => {
    return numberOfEvents > 40
      ? "#c0011d"
      : numberOfEvents > 20
      ? "#f43926"
      : numberOfEvents > 10
      ? "#ff8645"
      : numberOfEvents > 5
      ? "#fbb144"
      : numberOfEvents > 0
      ? "#ffd672"
      : numberOfEvents < 1
      ? "#f8ffb8"
      : "";
  };

  const style = (feature) => {
    var color1 = "null";
    if (feature.properties.maptype == "Province") color1 = "black";

    return {
      fillColor: mapPolygonColorToEvents(feature.properties.NYSEvents),
      weight: 1,
      opacity: 1,
      color: color1,
      dashArray: "2",
      fillOpacity: 0.75,
    };
  };

  const mapStyle = {
    height: "600px",
    width: width,
    margin: "0 auto",
    zIndex: 1,
  };

  const findDistrictCount = (district) => {
    return data?.find(
      (record) =>
        (record.type + " Municipality").toLowerCase() == district.toLowerCase()
    );
  };

  const feature = mapDisplayData.features.map((feature) => {
    const district = findDistrictCount(feature.properties.name);
    if (district) {
      feature.properties.NYSEvents = district.percent;
    } else {
      feature.properties.NYSEvents = 0;
      // mapDisplayData.features.splice(mapDisplayData.features.indexOf(feature), 1)
      return null;
    }
    return feature;
  });

  return (
    <div className="district-container">
      <div className="header">
        {/* <h2 className='heading'>Origin of NYS Candidates</h2> */}
        {/* <p className="text-muted">A choropleth map displaying Kenya population density as per the national census conducted <br />in 2019
                  Each County, details displayed by the map include, total population and number of each gender.</p> */}
      </div>
      <div className="">
        <div className="">
          {!onselect.name && (
            <div className={annotatedCssContainer}>
              <strong>{hoverText}</strong>
              <p>Hover on each District for more details</p>
            </div>
          )}
          {onselect.name && (
            <ul className={annotatedCssText}>
              <li>
                <strong>{onselect.name}</strong>
              </li>
              <br />
              <li>
                Total {dataSource}:{onselect.NYSEvents}%
              </li>
            </ul>
          )}

          <MapContainer
            zoom={6}
            scrollWheelZoom={false}
            style={mapStyle}
            center={center}
            preferCanvas
          >
            {/* <TileLayer url="http://{s}.tile.osm.org/{z}/{x}/{y}.png" /> */}
            {feature && (
              <GeoJSON
                data={mapDisplayData.features}
                style={style}
                onEachFeature={onEachFeature}
              />
            )}
          </MapContainer>
        </div>
      </div>
    </div>
  );
};

export default DistrictMap;
